import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Submenu from './lis-submenu-component';
import SearchInput from './lis-global-search-input-component';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { authActionCreators } from '../../../stores/lis-auth-store';
import { navActionCreators } from '../../../stores/lis-nav-store';

class NavMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLogin: false,
            pathName: ''
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleClosingLoginOnOffClick = this.handleClosingLoginOnOffClick.bind(this);
        this.mousedownListener = this.mousedownListener.bind(this);
    }

    componentDidMount() {
        const pathName = this.props.location.pathname;
        this.setState({ pathName: pathName })

        document.body.addEventListener('mousedown', this.mousedownListener);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.setState(prevState => ({
                showLogin: false,
                pathName: this.props.location.pathname
            }));
        }
        if (this.props.location.pathname !== prevProps.location.pathname && this.props.isOpen) {
            this.props.slideoutToggle();
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('mousedown', this.mousedownListener)
    }

    mousedownListener(e) {
        if (this.state.showLogin) {
            const loginBox = document.getElementsByClassName("nav-submenu")[0];
            const profileLink = document.getElementsByClassName("profile-link")[0];
            const loginLink = document.getElementsByClassName("login-link")[0];
            if ((!loginBox || (loginBox !== e.target && !loginBox.contains(e.target))) &&
                (!loginLink || (loginLink !== e.target && !loginLink.contains(e.target))) &&
                (!profileLink || (profileLink !== e.target && !profileLink.contains(e.target)))) {
                this.handleClosingLoginOnOffClick();
            }
        }
    }

    handleClosingLoginOnOffClick() {
        if (this.state.showLogin) {
            this.setState({
                showLogin: false
            });
        }
    }

    handleClick(e) {
        e?.preventDefault();
        this.setState(prevState => ({
            showLogin: !prevState.showLogin
        }));
    }

    slideoutToggle() {
        this.props.slideoutToggle();
    }

    render() {
        const { isAuthenticated, userProfile } = this.props.login;
        // Make dynamic button based on user's auth state
        let button;
        if (!isAuthenticated) {
            button = <a className={"login-link"} aria-label={'login'} onClick={(e) => { this.handleClick(e) }} href={'/login'} onKeyDown={(e) => [" ", 'Enter'].includes(e.key) && this.handleClick(e)}>Login</a>
        } else {
            button = <a className={"profile-link"} aria-label={'profile'} onClick={(e) => { this.handleClick(e) }} onKeyDown={(e) => [" ", 'Enter'].includes(e.key) && this.handleClick(e)} href={'/profile'}>{userProfile.initials}</a>
        }
        // Make dynamic header based on URL path
        let header;
        let isBillPath = (this.state.pathName.includes('/bill-search') || this.state.pathName.includes("bill-details") || this.state.pathName.includes('watchlists'));
        if (isBillPath) {
            header = <h1>Bills &amp; Resolutions </h1>
        } else {
            header = <h1>Legislative Information System </h1>
        }
        // Assemble session-aware budget url
        let budgetUrl = "https://budget.lis.virginia.gov/";
        if (this.props.session) {
            // budgetUrl += `default/${this.props.session.SessionCode.substr(0, 4)}/${this.props.session.SessionCode.substr(4)}`
        }

        return (
            <nav>
                <div className="lis-links-content full">
                    <ul>
                        <li><a style={{ padding: "10px 0 0 0" }} href="http://vga.virginia.gov/">Virginia General Assembly</a> /</li>
                        <li><a style={{ padding: "10px 0 0 0" }} href="http://help.lis.virginia.gov/" target="_blank" rel="noreferrer">LIS Learning Center</a> /</li>
                        <li><Link to="/privacy" target="_blank" rel="noreferrer" style={{ padding: "10px 0 0 0" }}>Privacy Policy</Link> /</li>
                        <li>
                            <Link to="/home" style={{ padding: "10px 0 0 0" }}>LIS Home</Link> /
                        </li>
                        {!isAuthenticated && <li>
                            <Link to="/register-account" style={{ padding: "10px 0 0 0" }}>Register Account</Link> /
                        </li>}
                        <li onClick={e => e.stopPropagation()} className="parent-link">
                            {button}
                            <div className={this.state.showLogin ? "submenu-container open" : "submenu-container closed"}>
                                <Submenu history={this.props.history} isAuth={isAuthenticated} permissions={this.props.permissions} showProfileLinks={this.state.showLogin} />
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="grid-wrapper one-and-twopointfive halves">
                    <div className="menu-title">
                        <Link to="/home">LIS</Link>
                    </div>
                    <div className="menu-links">
                        <div className="menu-btn">
                            <button type="button" onClick={this.slideoutToggle.bind(this)} href="#menu" tabIndex="0" aria-label="Menu">Menu</button>
                        </div>
                        <ul>
                            <li>
                                <Link className="txt-blue" to={`/`}>Session Information</Link>
                            </li>
                            <li>
                                <Link className="txt-dark-blue" to="/bill-search">Bills & Resolutions</Link>
                            </li>
                            <li>
                                <a className="txt-green" target="_blank" href={`${budgetUrl}`}>State Budget</a>
                            </li>
                            <li>
                                <a className="txt-light-green" target="_blank" href="https://law.lis.virginia.gov/">Virginia Law</a>
                            </li>
                            <li>
                                <a className="txt-orange" target="_blank" href="https://rga.lis.virginia.gov/">Reports to the General Assembly</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div id="site-title-container" className={isBillPath ? 'bill-theme' : null}>
                    <div className="site-title-content grid-wrapper three-and-two">
                        {header}
                        <SearchInput />
                    </div>
                </div>
            </nav>
        )
    }
}

const Menu = connect(
    (state) => {
        const { login, nav } = state;
        return {
            login,
            nav
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, navActionCreators, authActionCreators), dispatch)
        }
    }
)(NavMenu)

export default withRouter(Menu);
